const Store = () => {};

export default Store;
